import { Dropdown } from 'primereact/dropdown';
import './deactivate-reason-dropdown.styles.css';

interface DeactivateReasonDropdownProps {
	reason: string;
	setReason: (value: string) => void;
	reasons: { label: string; value: string }[];
}

const DeactivateReasonDropdown = ({
	reason,
	setReason,
	reasons,
}: DeactivateReasonDropdownProps) => {
	return (
		<div className="deactivate-reason-dropdown-container">
			<label
				htmlFor="deactivate-reason-dropdown"
				className={`floating-label ${reason ? 'float' : ''}`}
			>
				Reason's for Leaving
			</label>
			<Dropdown
				id="deactivate-reason-dropdown"
				value={reason}
				options={reasons}
				onChange={(e) => setReason(e.value)}
				placeholder="Reason's for Leaving"
				className="deactivate-reason-modal-dropdown"
				pt={{
					panel: { className: 'deactivate-reason-dropdown-panel' },
					list: { className: 'deactivate-reason-dropdown-list' },
					item: { className: 'deactivate-reason-dropdown-item' },
				}}
			/>
		</div>
	);
};

export default DeactivateReasonDropdown;
